import React, { useState, useEffect } from 'react';

import './BaseContactLensModal.scss';

export const BaseContactLensModal = props => {
  const { title, isOpen, onClose, list, value, onSelect } = props;

  const [isClosing, setIsClosing] = useState(false);
  const [shouldRender, setShouldRender] = useState(isOpen);
  const [selectedOption, setSelectedOption] = useState(value);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      setIsClosing(false);
    } else if (!isOpen && shouldRender) {
      setIsClosing(true);
      const timeout = setTimeout(() => {
        setShouldRender(false);
        setIsClosing(false);
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [isOpen, shouldRender]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('base-contact-lens-modal__no-scroll');
    } else {
      document.body.classList.remove('base-contact-lens-modal__no-scroll');
    }

    return () => {
      document.body.classList.remove('base-contact-lens-modal__no-scroll');
    };
  }, [isOpen]);

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const containerClass = `base-contact-lens-modal__container ${
    isClosing ? 'base-contact-lens-modal__slide-down' : 'base-contact-lens-modal__slide-up'
  }`;

  if (!shouldRender) return null;

  return (
    <div className="base-contact-lens-modal">
      <div className="base-contact-lens-modal-backdrop" onClick={handleClose} />

      <div className={containerClass}>
        <div className="base-contact-lens-modal__header">
          <h5 className="base-contact-lens-modal__header-title">{title}</h5>

          <button className="base-contact-lens-modal__header-close" onClick={handleClose}>
            <span className="base-contact-lens-modal__header-close-icon" />
          </button>
        </div>

        <div className="base-contact-lens-modal__list-container">
          <ul className="base-contact-lens-modal__list">
            {list.map(({ key, option }) => (
              <li
                key={key}
                className="base-contact-lens-modal__list-item"
                data-selected={selectedOption === key}
                onClick={() => {
                  setSelectedOption(key);
                  onSelect(option);
                  handleClose();
                }}
              >
                <span>{option}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
